var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout-wrapper"},[_c('Header'),_c('main',{staticClass:"layout-main"},[_c('Sidebar'),_c('div',{staticClass:"layout-router-view"},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }